export default [{
	titulo: 'Portfólio',
	icone: 'menu-icon fa fa-caret-right',
	url: '/site/portfolio',
	visualizar: false,
	actions: [{
		value: false,
		name: 'Cadastrar'
	}, {
		value: false,
		name: 'Editar'
	}, {
		value: false,
		name: 'Apagar'
	}]
}]